import { randomNumber } from '../../../../utilities'
import { CriticalCareConstants } from './criticalCare.constants'
import { ICriticalCareAction, ICriticalCareState } from './criticalCare.types'

export const initialCriticalCareState: ICriticalCareState = {
  action: null,
  site: null,
  task: null,
  transducerZeroedPre: null,
  transducerZeroedPost: null,
  triggerUtilizedPre: null,
  triggerUtilizedPost: null,
  IABPFrequencyPre: null,
  IABPFrequencyPost: null,
  IABPAugmentationPre: null,
  IABPAugmentationPost: null,
  slowGasLeakAlarmPre: null,
  slowGasLeakAlarmPost: null,
  timingPre: null,
  timingPost: null,
  IABPFillPre: null,
  IABPFillPost: null,
  augmentationAlarmSetPre: null,
  augmentationAlarmSetPost: null,
  leftBrachialPulsePre: null,
  leftBrachialPulsePost: null,
  distalPulsePre: null,
  distalPulsePost: null,
  extremityRestrainedPre: null,
  extremityRestrainedPost: null,
  insertionSitePulsePost: null,
  insertionSitePulsePre: null,
  inflationPointPre: '',
  inflationPointPost: '',
  deflationPointPre: '',
  deflationPointPost: '',
  diastolicAugmentationPre: '',
  diastolicAugmentationPost: '',
  unaugmentedDiastolePre: '',
  unaugmentedDiastolePost: '',
  diastolicDipPre: '',
  diastolicDipPost: '',
  augmentedSystolePre: '',
  augmentedSystolePost: '',
  unaugmentedSystolePre: '',
  unaugmentedSystolePost: '',
  addToTimeline: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  assessedBy: null,
  rolePerforming: null,
  successfulAttempt: false,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  updateInputRows: false,
  type: 'Critical Care',
  isEkgImport: null,
  attempts: '1',
  nemsisCode: null,
  size: '',
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
}

export function criticalCareReducer(
  state: ICriticalCareState = initialCriticalCareState,
  action: ICriticalCareAction
): ICriticalCareState {
  switch (action.type) {
    case CriticalCareConstants.SET_ACTION:
      return { ...state, action: action.action }
    case CriticalCareConstants.SET_SITE:
      return { ...state, site: action.site }
    case CriticalCareConstants.SET_TASK:
      return { ...state, task: action.task }
    case CriticalCareConstants.SET_TRANSDUCER_ZEROED_PRE:
      return { ...state, transducerZeroedPre: action.transducerZeroedPre }
    case CriticalCareConstants.SET_TRANSDUCER_ZEROED_POST:
      return { ...state, transducerZeroedPost: action.transducerZeroedPost }
    case CriticalCareConstants.SET_TRIGGER_UTILIZED_PRE:
      return { ...state, triggerUtilizedPre: action.triggerUtilizedPre }
    case CriticalCareConstants.SET_TRIGGER_UTILIZED_POST:
      return { ...state, triggerUtilizedPost: action.triggerUtilizedPost }
    case CriticalCareConstants.SET_IABP_FREQUENCY_PRE:
      return { ...state, IABPFrequencyPre: action.IABPFrequencyPre }
    case CriticalCareConstants.SET_IABP_FREQUENCY_POST:
      return { ...state, IABPFrequencyPost: action.IABPFrequencyPost }
    case CriticalCareConstants.SET_IABP_AUGMENTATION_PRE:
      return { ...state, IABPAugmentationPre: action.IABPAugmentationPre }
    case CriticalCareConstants.SET_IABP_AUGMENTATION_POST:
      return { ...state, IABPAugmentationPost: action.IABPAugmentationPost }
    case CriticalCareConstants.SET_SLOW_GAS_LEAK_ALARM_PRE:
      return { ...state, slowGasLeakAlarmPre: action.slowGasLeakAlarmPre }
    case CriticalCareConstants.SET_SLOW_GAS_LEAK_ALARM_POST:
      return { ...state, slowGasLeakAlarmPost: action.slowGasLeakAlarmPost }
    case CriticalCareConstants.SET_TIMING_PRE:
      return { ...state, timingPre: action.timingPre }
    case CriticalCareConstants.SET_TIMING_POST:
      return { ...state, timingPost: action.timingPost }
    case CriticalCareConstants.SET_IABP_FILL_PRE:
      return { ...state, IABPFillPre: action.IABPFillPre }
    case CriticalCareConstants.SET_IABP_FILL_POST:
      return { ...state, IABPFillPost: action.IABPFillPost }
    case CriticalCareConstants.SET_AUGMENTATION_ALARM_SET_PRE:
      return { ...state, augmentationAlarmSetPre: action.augmentationAlarmSetPre }
    case CriticalCareConstants.SET_AUGMENTATION_ALARM_SET_POST:
      return { ...state, augmentationAlarmSetPost: action.augmentationAlarmSetPost }
    case CriticalCareConstants.SET_LEFT_BRACHIAL_PULSE_PRE:
      return { ...state, leftBrachialPulsePre: action.leftBrachialPulsePre }
    case CriticalCareConstants.SET_LEFT_BRACHIAL_PULSE_POST:
      return { ...state, leftBrachialPulsePost: action.leftBrachialPulsePost }
    case CriticalCareConstants.SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_PRE:
      return { ...state, distalPulsePre: action.distalPulsePre }
    case CriticalCareConstants.SET_DISTAL_PULSE_PRESENT_IN_AFFECTED_EXTREMITY_POST:
      return { ...state, distalPulsePost: action.distalPulsePost }
    case CriticalCareConstants.SET_INSERTION_SITE_PRE:
      return { ...state, insertionSitePulsePre: action.insertionSitePulsePre }
    case CriticalCareConstants.SET_INSERTION_SITE_POST:
      return { ...state, insertionSitePulsePost: action.insertionSitePulsePost }
    case CriticalCareConstants.SET_EXTREMITY_RESTRAINED_PRE:
      return { ...state, extremityRestrainedPre: action.extremityRestrainedPre }
    case CriticalCareConstants.SET_EXTREMITY_RESTRAINED_POST:
      return { ...state, extremityRestrainedPost: action.extremityRestrainedPost }
    case CriticalCareConstants.SET_INFLATION_POINT_PRE:
      return { ...state, inflationPointPre: action.inflationPointPre }
    case CriticalCareConstants.SET_INFLATION_POINT_POST:
      return { ...state, inflationPointPost: action.inflationPointPost }
    case CriticalCareConstants.SET_DEFLATION_POINT_PRE:
      return { ...state, deflationPointPre: action.deflationPointPre }
    case CriticalCareConstants.SET_DEFLATION_POINT_POST:
      return { ...state, deflationPointPost: action.deflationPointPost }
    case CriticalCareConstants.SET_DIASTOLIC_AUGMENTATION_PRE:
      return { ...state, diastolicAugmentationPre: action.diastolicAugmentationPre }
    case CriticalCareConstants.SET_DIASTOLIC_AUGMENTATION_POST:
      return { ...state, diastolicAugmentationPost: action.diastolicAugmentationPost }
    case CriticalCareConstants.SET_UNAUGMENTED_DIASTOLE_PRE:
      return { ...state, unaugmentedDiastolePre: action.unaugmentedDiastolePre }
    case CriticalCareConstants.SET_UNAUGMENTED_DIASTOLE_POST:
      return { ...state, unaugmentedDiastolePost: action.unaugmentedDiastolePost }
    case CriticalCareConstants.SET_DIASTOLIC_DIP_PRE:
      return { ...state, diastolicDipPre: action.diastolicDipPre }
    case CriticalCareConstants.SET_DIASTOLIC_DIP_POST:
      return { ...state, diastolicDipPost: action.diastolicDipPost }
    case CriticalCareConstants.SET_AUGMENTED_SYSTOLE_PRE:
      return { ...state, augmentedSystolePre: action.augmentedSystolePre }
    case CriticalCareConstants.SET_AUGMENTED_SYSTOLE_POST:
      return { ...state, augmentedSystolePost: action.augmentedSystolePost }
    case CriticalCareConstants.SET_UNAUGMENTED_SYSTOLE_PRE:
      return { ...state, unaugmentedSystolePre: action.unaugmentedSystolePre }
    case CriticalCareConstants.SET_UNAUGMENTED_SYSTOLE_POST:
      return { ...state, unaugmentedSystolePost: action.unaugmentedSystolePost }
    case CriticalCareConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case CriticalCareConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case CriticalCareConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case CriticalCareConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case CriticalCareConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case CriticalCareConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case CriticalCareConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case CriticalCareConstants.SET_TIME:
      return { ...state, time: action.time }
    case CriticalCareConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case CriticalCareConstants.SET_DATE:
      return { ...state, date: action.date }
    case CriticalCareConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case CriticalCareConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case CriticalCareConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case CriticalCareConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case CriticalCareConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case CriticalCareConstants.SET_STATE:
      return { ...action.criticalCareState }
    case CriticalCareConstants.SET_SIZE:
      return { ...state, size: action.size }
    case CriticalCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case CriticalCareConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case CriticalCareConstants.RESET_IABP_FIELDS:
      return {
        ...state,
        task: null,
        slowGasLeakAlarmPre: null,
        slowGasLeakAlarmPost: null,
        timingPre: null,
        timingPost: null,
        IABPFillPre: null,
        IABPFillPost: null,
        augmentationAlarmSetPre: null,
        augmentationAlarmSetPost: null,
        leftBrachialPulsePre: null,
        leftBrachialPulsePost: null,
        distalPulsePre: null,
        distalPulsePost: null,
        extremityRestrainedPre: null,
        extremityRestrainedPost: null,
        IABPFrequencyPre: null,
        IABPFrequencyPost: null,
        insertionSitePulsePre: null,
        insertionSitePulsePost: null,
        triggerUtilizedPre: null,
        triggerUtilizedPost: null,
      }
    case CriticalCareConstants.RESET_STATE:
      return {
        action: null,
        site: null,
        task: null,
        transducerZeroedPre: null,
        transducerZeroedPost: null,
        triggerUtilizedPre: null,
        triggerUtilizedPost: null,
        IABPFrequencyPre: null,
        IABPFrequencyPost: null,
        IABPAugmentationPre: null,
        IABPAugmentationPost: null,
        slowGasLeakAlarmPre: null,
        slowGasLeakAlarmPost: null,
        timingPre: null,
        timingPost: null,
        IABPFillPre: null,
        IABPFillPost: null,
        augmentationAlarmSetPre: null,
        augmentationAlarmSetPost: null,
        insertionSitePulsePost: null,
        insertionSitePulsePre: null,
        leftBrachialPulsePre: null,
        leftBrachialPulsePost: null,
        distalPulsePre: null,
        distalPulsePost: null,
        extremityRestrainedPre: null,
        extremityRestrainedPost: null,
        inflationPointPre: '',
        inflationPointPost: '',
        deflationPointPre: '',
        deflationPointPost: '',
        diastolicAugmentationPre: '',
        diastolicAugmentationPost: '',
        unaugmentedDiastolePre: '',
        unaugmentedDiastolePost: '',
        diastolicDipPre: '',
        diastolicDipPost: '',
        augmentedSystolePre: '',
        augmentedSystolePost: '',
        unaugmentedSystolePre: '',
        unaugmentedSystolePost: '',
        addToTimeline: false,
        key: randomNumber().toString(),
        date: '',
        time: '',
        pta: false,
        assessedBy: null,
        rolePerforming: null,
        successfulAttempt: false,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        updateInputRows: true,
        type: 'Critical Care',
        isEkgImport: null,
        nemsisCode: null,
        attempts: '1',
        size: '',
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
      }
    default:
      return state
  }
}
